import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { RootState } from 'reducers';
import { AdyenConfig } from 'containers/Forms/Settings/views/Payment/components/Adyen/types';

import { getCafaEntry } from '../../reducers/cafaConfigs';
import { INTEGRATION_TYPES, INTEGRATIONS } from '../../constants/CAFA';

import { askForAdditionalDataPerType } from './utils/additionalDataPrompt';

const TIP = {
  OPTIONS: {
    NEVER: 'never',
    ALWAYS: 'always',
    ASK: 'ask',
  },
  PARAMS: {
    ALLOWED: {
      tipping: true,
    },
    DISALLOWED: {
      tipping: false,
    },
  },
};

export const getAdyenTipParams = () => async (
  dispatch: ThunkDispatch<RootState, unknown, Action>,
  getState: () => RootState,
) => {
  const { value: config } =
    getCafaEntry<'payment', 'adyen', AdyenConfig>(
      INTEGRATIONS.payment.adyen,
      INTEGRATION_TYPES.payment,
    )(getState()) || {};

  const { OPTIONS, PARAMS } = TIP;

  switch (config?.tipping) {
    case OPTIONS.ALWAYS:
      return Promise.resolve(PARAMS.ALLOWED);
    case OPTIONS.ASK:
      return dispatch(askForAdditionalDataPerType('tipping')).then(isAllowed =>
        isAllowed ? PARAMS.ALLOWED : PARAMS.DISALLOWED,
      );
    case OPTIONS.NEVER:
    default:
      return Promise.resolve(PARAMS.DISALLOWED);
  }
};
